import React from 'react';
import ReactDOM from 'react-dom/client';
import { bootstrapTheme } from '@mgp/ui';

import '@fontsource-variable/inter';
import '@fontsource/cinzel/400.css';
import '@fontsource/cinzel/600.css';
import '@fontsource/cinzel/700.css';

import { App } from './App';
import './styles/index.css';

bootstrapTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
